// DRIPSY Theme JS — Clean Build
(function () {

  const toast = document.getElementById('DripsyToast');

  /* ===========================
     Position Toast Under DRIPSY
  =========================== */
  function positionToastUnderBrand() {
    const brand = document.getElementById('DripsyBrand');
    if (!toast || !brand) return;

    const rect = brand.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;

    toast.style.left = `${centerX}px`;
  }

  /* ===========================
     Show Toast
  =========================== */
  function showToast(message) {
    if (!toast) return;

    positionToastUnderBrand();

    toast.textContent = message;
    toast.classList.add('show');

    clearTimeout(showToast._t);
    showToast._t = setTimeout(() => {
      toast.classList.remove('show');
    }, 2400);
  }

  window.addEventListener('resize', positionToastUnderBrand);

  /* ===========================
     Image Thumbnail Switcher
  =========================== */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.thumb');
    if (!btn) return;

    const src = btn.getAttribute('data-src');
    if (!src) return;

    const scope =
      btn.closest('[data-product-media]') ||
      btn.closest('.product') ||
      document;

    const mainImg =
      scope.querySelector('.product-image') ||
      document.querySelector('.product-image');

    if (mainImg) {
      mainImg.src = src;
      scope.querySelectorAll('.thumb.is-active')
        .forEach(el => el.classList.remove('is-active'));
      btn.classList.add('is-active');
    }
  });

  /* ===========================
     AJAX Add To Vault
  =========================== */
  async function addToVault(form) {
    if (!form || !(form instanceof HTMLFormElement)) return;

    if (form.dataset.submitting === '1') return;
    form.dataset.submitting = '1';

    const formData = new FormData(form);

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
        credentials: 'same-origin'
      });

      if (!res.ok) throw new Error('Add failed');

      const addedItem = await res.json().catch(() => null);

      const title =
        (addedItem && addedItem.title) ||
        document.querySelector('[data-product-title]')?.textContent?.trim() ||
        document.querySelector('.product-title')?.textContent?.trim() ||
        document.querySelector('h1')?.textContent?.trim() ||
        '';

      // Update Vault count
      const cartRes = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      });

      if (cartRes.ok) {
        const cart = await cartRes.json();
        document.querySelectorAll('.cart-count')
          .forEach(el => el.textContent = String(cart.item_count || 0));
      }

      showToast(title ? `Added to Vault · ${title}` : 'Added to Vault');

    } catch (err) {
      showToast('Could not add');
    } finally {
      form.dataset.submitting = '0';
    }
  }

  /* ===========================
     Intercept Form Submits
  =========================== */
  document.addEventListener('submit', function (e) {
    const form = e.target;
    if (!form || !(form instanceof HTMLFormElement)) return;

    const action = (form.getAttribute('action') || '').toLowerCase();
    if (!action.includes('/cart/add')) return;

    e.preventDefault();
    addToVault(form);
  }, true);
  // ===========================
// DRIPSY — Mini Vault dropdown
// ===========================
const miniVault = document.getElementById('DripsyMiniVault');
const miniVaultItems = document.getElementById('DripsyMiniVaultItems');
const vaultTrigger = document.querySelector('.dripsy-vault-trigger');
const vaultClose = miniVault ? miniVault.querySelector('.dripsy-mini-vault__close') : null;

function money(cents){
  // simple money formatting (AUD-ish); adjust if needed
  const n = (cents || 0) / 100;
  return n.toLocaleString(undefined, { style: 'currency', currency: 'AUD' });
}

function renderMiniVault(cart){
  if(!miniVaultItems) return;

  const items = (cart && cart.items) ? cart.items : [];
  if(items.length === 0){
    miniVaultItems.innerHTML = `<div class="dripsy-mini-vault__empty">Vault is empty.</div>`;
    return;
  }

  miniVaultItems.innerHTML = items.slice(0, 6).map(item => {
    const img = item.image ? item.image : '';
    const title = item.product_title || item.title || 'Item';
    const qty = item.quantity || 1;
    const line = item.final_line_price ?? item.line_price ?? 0;

    return `
      <div class="dripsy-mini-vault__row">
        <div class="dripsy-mini-vault__img">
          ${img ? `<img src="${img}" alt="">` : ``}
        </div>
        <div>
          <p class="dripsy-mini-vault__name">${title}</p>
          <p class="dripsy-mini-vault__meta">${money(line)}</p>
        </div>
        <div class="dripsy-mini-vault__qty">x${qty}</div>
      </div>
    `;
  }).join('');
}

async function loadMiniVault(){
  if(!miniVaultItems) return;
  miniVaultItems.innerHTML = `<div class="dripsy-mini-vault__loading">Loading…</div>`;

  const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  const cart = await res.json();
  renderMiniVault(cart);
}

function openMiniVault(){
  if(!miniVault || !vaultTrigger) return;
  miniVault.classList.add('open');
  miniVault.setAttribute('aria-hidden', 'false');
  vaultTrigger.setAttribute('aria-expanded', 'true');
  loadMiniVault();
}

function closeMiniVault(){
  if(!miniVault || !vaultTrigger) return;
  miniVault.classList.remove('open');
  miniVault.setAttribute('aria-hidden', 'true');
  vaultTrigger.setAttribute('aria-expanded', 'false');
}

if(vaultTrigger && miniVault){
  vaultTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    if(miniVault.classList.contains('open')) closeMiniVault();
    else openMiniVault();
  });

  if(vaultClose){
    vaultClose.addEventListener('click', (e) => {
      e.preventDefault();
      closeMiniVault();
    });
  }

  // click outside closes
  document.addEventListener('click', (e) => {
    if(!miniVault.classList.contains('open')) return;
    const inside = e.target.closest('#DripsyMiniVault') || e.target.closest('.dripsy-vault-trigger');
    if(!inside) closeMiniVault();
  });

  // esc closes
  document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape') closeMiniVault();
  });
}

// Optional: when cart count updates elsewhere, mini vault stays fresh next open

})();